export default "__VITE_ASSET__CKmRHBIU__"